import styled from "styled-components";

export const Title = styled.h1`
  font-family: ${(props) => props.theme.fonts.aeonik};
  font-weight: 500;
  font-size: 30px;
  line-height: 40px;
  font-style: normal;
  width: 100%;

  span {
    color: ${(props) => props.theme.colors.neutrals.primary.graytext};
  }
`;

export const PreText = styled.div`
  padding-bottom: 2px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.neutrals.primary.graytext};
`;

export const TitleContainer = styled.div`
  padding-right: 24px;
`;

export const Controls = styled.div`
  padding-bottom: 4px;

  &.with-pre {
    padding-top: 20px;
  }
`;

export const Container = styled.div<{ $displayVertical?: boolean }>`
  width: 100%;
  display: ${(props) => (props.$displayVertical ? "block" : "flex")};
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;

  @media ${(props) => props.theme.device.md} {
    display: flex;
  }
`;
